import React, { useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import "./BtnEcouteMarche.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateMenu } from "Redux/Actions/menuActions";
import { updateAuth } from "Redux/Actions/authActions";
import axios from "axios";
import { Toast } from "primereact/toast";
import { useTranslation } from "react-i18next";

const BtnEcouteMarche = (props) => {
  const successUpdate = useRef(null);
  const { t } = useTranslation("common");
  // État local : la case réagit immédiatement au clic, sans attendre le retour du PUT ni le
  // rafraîchissement du store (RC-264 : case « non cliquable » quand l'appel échouait en silence).
  const [isChecked, setIsChecked] = useState(
    Boolean(props.auth.userConnected?.availableToWork)
  );

  // Resynchronisation si le profil est rechargé par ailleurs (autre onglet, refresh du store).
  useEffect(() => {
    setIsChecked(Boolean(props.auth.userConnected?.availableToWork));
  }, [props.auth.userConnected?.availableToWork]);

  const showError = (err) => {
    const detail =
      err?.response?.data?.violations?.[0]?.message ||
      err?.response?.data?.detail ||
      "Une erreur est survenue";
    const toast = props.auth.toast?.current || successUpdate.current;
    toast?.clear();
    toast?.show({
      severity: "error",
      summary: "Erreur",
      detail,
      life: 5000,
    });
  };

  const putDataToApi = (data, previousValue) => {
    const { availableToWork } = data;
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}`,
        { availableToWork },
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                "Content-Type": "application/json",

                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
                "Content-Type": "application/json",
              },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          props.handleUpdateAuth({ userConnected: res.data });
          showSuccess();
        }
      })
      .catch((err) => {
        // Retour à l'ancienne valeur si l'appel échoue, et affichage du motif renvoyé par l'API
        setIsChecked(previousValue);
        showError(err);
      });
  };
  const showSuccess = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Mise à jour effectuée avec succès",
      detail: "Votre mise à jour a bien été prise en compte",
      life: 3000,
    });
  };

  const handleCheckboxChange = (e) => {
    const previousValue = isChecked;
    const newCheckedState = Boolean(e.checked);
    setIsChecked(newCheckedState);

    const userUpdate = {
      ...props.auth.userConnected,
      availableToWork: newCheckedState,
    };
    const userObj = { ...userUpdate };
    delete userObj.id;
    putDataToApi(userObj, previousValue);
  };

  return (
    <div className="ecoute_marche">
      <Toast ref={successUpdate} />
      <div className="ecoute_marche_button">
        <Checkbox
          inputId="availableToWork"
          onChange={handleCheckboxChange}
          checked={isChecked}
        />
        <label htmlFor="availableToWork" className="ecoute_marche-label">
          {t("profilEdition.privacySettings.availableToWork")}
        </label>
      </div>

      <h6>{t("profilEdition.privacySettings.disclaimerOne")}</h6>
      <h6>
        {t("profilEdition.privacySettings.disclaimerTwo")}
        <a
          onClick={() =>
            props.handleMenu({
              activeItemProfilEdit: props.items.itemsProfilEdit.findIndex(
                (v) => v.label == "Paramètres de confidentialité"
              ),
            })
          }
        >
          {t("profilEdition.privacySettings.title")}
        </a>
        .
      </h6>
    </div>
  );
};

BtnEcouteMarche.propTypes = {
  items: PropTypes.any,
  auth: PropTypes.any,
  handleMenu: PropTypes.func,
  handleUpdateAuth: PropTypes.func,
};

const mapStateToProps = (state) => ({
  items: state.items,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
  handleUpdateAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BtnEcouteMarche);
